export default __webpack_public_path__ + "static/amber-c507c872f274d5c168fe830f5b7e1de3.svg";